export default __webpack_public_path__ + "static/swiss-augenzentrum-ag-085da3b3663df35e2a2d97c3935b411a.png";